var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.66677H13.1667M11.5 8.0001H13.1667M13.1667 11.3334H4.83333M4.83333 4.66677V8.0001H8.16667V4.66677H4.83333ZM3.16667 14.6668H14.8333C15.2754 14.6668 15.6993 14.4912 16.0118 14.1786C16.3244 13.8661 16.5 13.4421 16.5 13.0001V3.0001C16.5 2.55807 16.3244 2.13415 16.0118 1.82159C15.6993 1.50903 15.2754 1.33344 14.8333 1.33344H3.16667C2.72464 1.33344 2.30072 1.50903 1.98816 1.82159C1.67559 2.13415 1.5 2.55807 1.5 3.0001V13.0001C1.5 13.4421 1.67559 13.8661 1.98816 14.1786C2.30072 14.4912 2.72464 14.6668 3.16667 14.6668Z",
    stroke: "#FF7C02",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogsvg);
export default __webpack_public_path__ + "static/media/blogsvg.b7800bde33b3d703d44ce33bdb467875.svg";
export { ForwardRef as ReactComponent };